/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_CoverageInputs */

const en_clients_field_contract_coverage = /** @type {(inputs: Clients_Field_Contract_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case coverage`)
};

const pt_br2_clients_field_contract_coverage = /** @type {(inputs: Clients_Field_Contract_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura de casos`)
};

/**
* | output |
* | --- |
* | "Case coverage" |
*
* @param {Clients_Field_Contract_CoverageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_coverage = /** @type {((inputs?: Clients_Field_Contract_CoverageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_CoverageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_coverage(inputs)
	return pt_br2_clients_field_contract_coverage(inputs)
});